import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuAdmin } from "../MenuAdmin"
import { Header } from "../../common/header/Header"
import { IMG } from "../../common/CONST"
import { IModalMessage } from "../../../types/error/IModalMessage"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IUser } from "../../../types/user/IUser"
import { IPageResponse } from "../../../types/IPageResponse"
import { UserListItem } from "./UserListItem"
import InfiniteScroll from "react-infinite-scroll-component"
import { useNavigate, useSearchParams } from "react-router-dom"
import { IErrorModel } from "../../../types/error/IErrorModel"
import Input from "@/ui/components/Input"
import Button from "@/ui/components/Button"
import { ADMIN_USER_NEW_ROUTE } from "@/routes"
import Skeleton from "@/ui/components/Skeleton"
import EmptyRow from "@/ui/components/EmptyRow"
import { useUpdateEffect } from "react-use"
import { useStore } from "@/stores/RootStoreContext"
import { MenuManager } from "@/components/manager/MenuManager"

export const UserList = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { userStore } = useStore()

  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const [searchQuery, setSearchQuery] = useState("")
  const [userList, setUserList] = useState<IPageResponse<IUser>>()
  const [page, setPage] = useState(0)
  const [isLoading, setLoading] = useState(true)
  const [extendedUserId, setExtendedUserId] = useState<number | null>(null)

  const isUsersRole = searchParams.get("role") === "ROLE_CLIENT"

  const fetchUsers = () => {
    TrinityAPI.getUserList(
      searchParams.get("role") || "",
      page,
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 ? new Array<IUser>() : userList?.items || new Array<IUser>()
          setPage(page + 1)
          setUserList({
            ...userList,
            items: currentItems.concat(response.data.items),
            totalPages: response.data.totalPages
          })
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки реестра: " + response.data.message })
        }
      },
      () => setLoading(false)
    )
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setPage(0)
    }
  }

  const remove = (userId: number) => {
    if (!userId) return
    TrinityAPI.removeUser(userId, response => {
      if (response.status === 200) {
        let newItems = userList?.items.filter(i => i.userId !== userId) || new Array<IUser>()
        setUserList({ ...userList, items: newItems, totalPages: userList?.totalPages || 0 })
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const ban = (userId: number) => {
    TrinityAPI.banUser(userId, response => {
      if (response.status === 200) {
        let newItems = userList?.items.map(i => {
          if (i.userId === userId) {
            i.isBanned = !i.isBanned
            return i
          } else {
            return i
          }
        })
        setUserList({ ...userList, items: newItems || new Array<IUser>(), totalPages: userList?.totalPages || 0 })
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  useEffect(() => {
    if (page === 0) {
      fetchUsers()
    }
  }, [page])

  useUpdateEffect(() => {
    setPage(0)
  }, [searchParams])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
      {userStore.isManager ? (
        <MenuManager active={"client"} />
      ) : (
        <MenuAdmin active={searchParams.get("role") === "ROLE_MANAGER" ? "manager" : "client"} />
      )}
      <main className="main-container" id="scrollable">
        <Header />

        <div className="container">
          <h1 className="ui-heading">
            Реестр {searchParams.get("role") === "ROLE_MANAGER" ? "менеджеров" : "пользователей"}
          </h1>

          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.profile} alt="" className="header-chapter-img" />
              </div>
              <h2 className="heading-chapter">
                Все {searchParams.get("role") === "ROLE_MANAGER" ? "менеджеры" : "пользователи"}
              </h2>
            </div>
            {searchParams.get("role") === "ROLE_MANAGER" && (
              <Button
                id="manager"
                onClick={() => navigate(ADMIN_USER_NEW_ROUTE)}
                leftIcon={<img src={IMG.plus_btn} alt="" className="img-btn" />}
              >
                Добавить
              </Button>
            )}
          </section>

          <section className="search-block">
            <Input
              type="search"
              placeholder="Введите имя или email"
              onKeyDown={handleKeyDown}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </section>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item cols-4">Имя</li>
                <li className="header-global-item cols-4">Email</li>
                <li className="header-global-item cols-4">Telegram</li>
                <li className="header-global-item cols-4">Телефон</li>
              </ul>
              <ul className="global-list">
                {isLoading ? (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                ) : (
                  <InfiniteScroll
                    scrollableTarget="scrollable"
                    next={fetchUsers}
                    hasMore={page < (userList?.totalPages || 0)}
                    loader={<>Загрузка...</>}
                    dataLength={userList?.items.length || 0}
                    className="message-list"
                    style={{ listStyleType: "none" }}
                  >
                    {(userList?.items?.length || 0) > 0 ? (
                      userList?.items.map((u, index) => (
                        <UserListItem
                          extendedUserId={extendedUserId}
                          setExtendedUserId={setExtendedUserId}
                          isUsersRole={isUsersRole}
                          user={u}
                          remove={remove}
                          ban={ban}
                          key={index}
                        />
                      ))
                    ) : (
                      <EmptyRow text="Пользователей не найдено" />
                    )}
                  </InfiniteScroll>
                )}
              </ul>
            </section>
          </div>
        </div>
      </main>
    </>
  )
}
